import React from "react";
import { Container} from 'react-bootstrap';
import Row from "react-bootstrap/Row";
import SideBar from "./sidebar";
import Content from "./content";

function Main() {
    return <Container fluid className="mt-3">
        <Row>
            <SideBar />
            <Content />
        </Row>
    </Container>
}

export default Main